const TEXTS = ['black', 'white'];

export default TEXTS;
